<template>
  <div style="position: relative; height: 100%;" >
    <input ref="UploadFile" type="file" style="display: none;" @change="onUploadFiles" multiple v-if="hasFolderPermission(folderPermission.WRITE, folder)"/>
    <div v-if="sendingFiles.length" class="mb-3" style="background-color: rgb(235, 235, 235);">
      <h5 class="pt-3 pl-3">
        <span v-html="$lang.Documents.File.LabelSendingFiles">
        </span>
      </h5>
      <div class="d-flex flex-wrap p-3" >
        <div class="m-1" v-for="sendingFile in sendingFiles" :key="sendingFile.id">
          <b-badge class="my-2 p-2" :class="sendingFile.erro ? 'badge-danger' : 'badge-light'" active>
            <div class="d-flex justify-content-between pb-1" v-if="sendingFile.erro">
              <i class="fas fa-redo-alt pointer" @click="retrySending(sendingFile)"></i>
              <i class="fas fa-times pointer" @click="removeSending(sendingFile)"></i>
            </div>
            {{ sendingFile.path }} {{ sendingFile.loaded }}
            <b-progress v-if="!sendingFile.erro" height="5px" :value="sendingFile.percent" ></b-progress>
          </b-badge>
        </div>
      </div>
    </div>

    <div id="dropzone" @dragenter.prevent.stop="onDragEnter" @dragover.prevent.stop="onDragOver" @drop.prevent.stop="">
      <div id="dragHover"
           class="fas fa-cloud-upload-alt"
           :class="{'d-flex': isDragging}"
           style="position:absolute; inset:0px; align-items:center; justify-content:center; background-color:#ccc; z-index:3; font-size:8rem; display:flex;"
           v-show="isDragging"
           @dragleave.prevent.stop="onDragLeave"
           @drop.prevent.stop="onDropFiles">
      </div>

      <div v-show="editingFile">
        <Forms ref="formEditFile"
               :title="$lang.Documents.File.TitleForm"
               :showBackButton="true"
               :showSaveButton="true"
               v-on:Back="onBackEditFile"
               v-on:Save="onSave">
          <div class="row">
            <div class="col-md-12">
              <b-tabs v-model="tabIndex">
                <b-tab :title="$lang.Documents.File.LabelTabFile">
                  <div class="row">
                    <div class="form-group col-md-12 mb-3">
                      <label for="txtName">{{$lang.Documents.LabelName}}:</label>
                      <div class="input-group align-items-center">
                        <b-form-input type="text"
                                      name="txtName"
                                      ref="txtName"
                                      v-model="form.nome.value"
                                      :maxlength="form.nome.maxlength"
                                      :required="form.nome.required"
                                      :state="form.nome.state" />
                      </div>
                    </div>
                    <div class="form-group col-md-3 mb-3">
                      <label for="selType">{{$lang.Documents.LabelType}}:</label>
                      <b-form-select ref="selType"
                                     v-model="form.gedTipoID.value"
                                     :options="form.gedTipoID.options"
                                     :required="form.gedTipoID.required"
                                     :state="form.gedTipoID.state">
                        <template slot="first">
                          <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                        </template>
                      </b-form-select>
                    </div>
                    <div class="form-group col-md-3 mb-3">
                      <label for="selSubject">{{$lang.Documents.LabelSubject}}:</label>
                      <b-form-select ref="selSubject"
                                     v-model="form.gedAssuntoID.value"
                                     :options="form.gedAssuntoID.options"
                                     :required="form.gedAssuntoID.required"
                                     :state="form.gedAssuntoID.state">
                        <template slot="first">
                          <option :value="null">{{$lang.Common.PlaceholderSelect}}</option>
                        </template>
                      </b-form-select>
                    </div>
                    <div class="form-group col-md-3 mb-3">
                      <label for="txtStart">{{$lang.Documents.File.LabelStart}}:</label>
                      <b-form-input name="txtStart"
                                    type="date"
                                    v-model="form.inicio.value"
                                    :required="form.inicio.required"
                                    :state="form.inicio.state" />
                    </div>
                    <div class="form-group col-md-3 mb-3">
                      <label for="txtValidate">{{$lang.Documents.File.LabelValidate}}:</label>
                      <b-form-input name="txtValidate"
                                    type="date"
                                    v-model="form.validade.value"
                                    :required="form.validade.required"
                                    :state="form.validade.state" />
                    </div>
                    <div class="form-group col-md-2 mb-3" v-if="form.validade.value">
                      <label for="txtAlertDays">{{$lang.Documents.File.LabelAlertDays}}:</label>
                      <b-form-input name="txtAlertDays"
                                    type="number"
                                    v-model="form.diasAlerta.value"
                                    :required="form.diasAlerta.required"
                                    :state="form.diasAlerta.state" />
                    </div>
                    <div class="form-group col-md-10 mb-3" v-if="form.diasAlerta.value">
                      <label for="txtAlertEmails">{{$lang.Documents.File.LabelAlertEmails}}</label>
                      <b-form-input name="txtAlertEmails"
                                    type="text"
                                    v-model="form.emailsAlerta.value"
                                    :required="form.emailsAlerta.required"
                                    :state="form.emailsAlerta.state" />
                    </div>
                    <div class="form-group col-md-12 mb-3">
                      <label for="txtTag">{{$lang.Documents.LabelTags}}:</label>
                      <tags-input name="txtTag"
                                  :placeholder="$lang.Documents.PlaceholderTags"
                                  v-model="selectedTags"
                                  :existing-tags="form.gedTagID.options"
                                  :typeahead="true"
                                  :typeaheadHideDiscard="true"
                                  id-field="value"
                                  text-field="text"
                                  style="font-size: 14px;" />
                    </div>
                    <div class="form-group col-md-12 mb-3">
                      <label for="txtObs">{{$lang.Documents.File.LabelObservation}}:</label>
                      <b-form-textarea name="txtObs"
                                       ref="txtObs"
                                       v-model="form.observacao.value"
                                       :required="form.observacao.required"
                                       :state="form.observacao.state" />
                    </div>
                  </div>
                </b-tab>
                <b-tab :title="$lang.Documents.File.LabelTabHistory" lazy>
                  <FileHistory :file="data" />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </Forms>
      </div>
      <Tables v-show="!editingFile"
              id="table"
              ref="tableGrid"
              :messageTipFooter="$lang.Common.ClickToSelect"
              :showDownload="selectedCount > 1 && hasFolderPermission(folderPermission.DOWNLOAD, folder)"
              :showHistory="folder && !isUndeleting && !editingFile"
              :showFullscreen="false"
              :showPrint="false"
              :showShare="false"
              :showSettings="false"
              :showReload="false"
              :pagingLimitDefault="100"
              v-on:SaveFile="onDownloadFiles"
              v-on:DeleteFile="onDeleteFile"
              v-on:Load="onLoad"
              v-on:History="onHistory" >
        <template v-slot:formBeforeTable>
          <div class="row align-items-end" v-if="folder && !isUndeleting && !editingFile && !showHistory && hasFolderPermission(folderPermission.WRITE, folder)">
            <div class="col">
              <b-link href="#" @click="$refs.UploadFile.click()">
                <i class="fas fa-cloud-upload-alt mr-1 mt-3 ml-3"></i><span v-html="$lang.Documents.File.LabelDropFiles"></span>
              </b-link>
            </div>
            <div class="col text-right">
              <b-form-checkbox v-model="showMiniatures" v-if="hasFolderPermission(folderPermission.DOWNLOAD, folder)" @change="loadImages" class="mt-3 mr-3" switch>
                {{$lang.Documents.File.LabelShowMiniatures}}
              </b-form-checkbox>
            </div>
          </div>
          <div v-else-if="showHistory">
            <FolderHistory ref="FolderHistory" />
          </div>
        </template>

        <template #thead>
          <tr>
            <th>
              <div v-if="selectedCount === 0">
                <span @click="selectAll(true)">
                  <i class="far fa-square" style="font-size: 15px;"></i>
                </span>
              </div>
              <div v-else-if="selectedCount < objList.length">
                <span @click="selectAll(false)">
                  <i class="fas fa-minus-square" style="font-size: 15px;"></i>
                </span>
              </div>
              <div v-else>
                <span @click="selectAll(false)">
                  <i class="fas fa-check-square" style="font-size: 15px;"></i>
                </span>
              </div>
            </th>
            <th v-if="folder && !folder.gedChecklistID && showMiniatures">{{$lang.Documents.File.DataTable.Miniatures}}</th>
            <th v-if="folder && !folder.gedChecklistID" class="text-left"><span>{{$lang.Documents.LabelName}}</span></th>
            <!-- <th v-else><span>Tipo</span></th> -->
            <th v-if="folder && folder.gedChecklistID && showMiniatures">{{$lang.Documents.File.DataTable.Miniatures}}</th>
            <th v-if="folder && folder.gedChecklistID" class="text-left"><span>{{$lang.Documents.LabelName}}</span></th>
            <th v-else><span>{{$lang.Documents.LabelType}}</span></th>
            <th><span>{{$lang.Documents.LabelSubject}}</span></th>
            <th><span>{{$lang.Documents.File.DataTable.Version}}</span></th>
            <th><span>{{$lang.Documents.File.DataTable.Size}}</span></th>
            <th><span>{{$lang.Documents.File.DataTable.LastAction}}</span></th>
            <th><span>{{$lang.Documents.LabelTags}}</span></th>
            <th><span>{{$lang.Documents.File.DataTable.Obs}}</span></th>
            <th><span>{{$lang.Documents.File.DataTable.Start}}</span></th>
            <th><span>{{$lang.Documents.File.DataTable.Validate}}</span></th>
            <th></th>
          </tr>
        </template>

        <tr v-for="(obj, index) in this.objList" v-bind:key="obj.id">
          <TableColumn v-if="!obj.gedChecklistTipo" :IsCustom="true" :status="obj.status">
            <b-form-checkbox @change="checkChanged(obj)" :id="`cbxDoc-${index}`" v-model="obj.checked" :name="`cbxDoc-${index}`" :value="true" size="sm" plain :disabled="!obj.status"/>
          </TableColumn>
          <TableColumn v-if="!folder.gedChecklistID && !obj.gedChecklistTipo && showMiniatures" :IsCustom="true" :status="obj.status">
            <img :src="'data:image/jpeg;base64,' + obj.miniature" v-if="obj.formato === 'IMG' && obj.miniature" style="width:auto; height:70px;">
            <b-spinner variant="success" v-else-if="obj.formato ==='IMG'" label="Carregando" style="width:68px; height:68px;"></b-spinner>
            <i :class="classFormat(obj.formato)" style="font-size: 70px;" v-else></i>
          </TableColumn>
          <TableColumn v-if="!folder.gedChecklistID && !obj.gedChecklistTipo" :IsCustom="true" :status="obj.status" classCss="text-left">
            <b-link href="#" @click="onPreviewFile(obj)" :class="{'text-danger':(Boolean(obj.status) === false)}">
              <i :class="classFormat(obj.formato)" style="font-size: 15px;" v-if="!showMiniatures"></i> {{ obj.nome }}
            </b-link>
            <b-link href="#"
                    v-if="['IMG', 'PDF'].includes(obj.formato) && hasFolderPermission(folderPermission.DOWNLOAD, folder)"
                    @click="onPreviewFile(obj)"
                    class="ml-2"
                    :class="{'text-danger':(Boolean(obj.status) === false)}"
                    v-b-tooltip.hover title="Clique para visualizar o conteúdo">
              <i class="far fa-eye text-default" style="font-size: 14px;"></i>
            </b-link>
          </TableColumn>
          <!-- <TableColumn v-if="folder.gedChecklistID && !obj.gedChecklistTipo" :IsText="true" v-on:Edit="onEditFile(obj)" :status="obj.status" :value="obj.gedTipo ? obj.gedTipo.nome : null" /> -->
          <TableColumn v-if="folder.gedChecklistID && !obj.gedChecklistTipo && showMiniatures" :IsCustom="true" :status="obj.status">
            <img :src="'data:image/jpeg;base64,' + obj.miniature" v-if="obj.formato === 'IMG' && obj.miniature" style="width:auto; height:70px;">
            <b-spinner variant="success" v-else-if="obj.formato ==='IMG'" label="Carregando" style="width:68px; height:68px;"></b-spinner>
            <i :class="classFormat(obj.formato)" style="font-size: 70px;" v-else></i>
          </TableColumn>
          <TableColumn v-if="folder.gedChecklistID && !obj.gedChecklistTipo" :IsCustom="true" :status="obj.status" classCss="text-left">
            <b-link href="#" @click="onPreviewFile(obj)" :class="{'text-danger':(Boolean(obj.status) === false)}">
              <i :class="classFormat(obj.formato)" style="font-size: 15px;" v-if="!showMiniatures"></i> {{ obj.nome }}
            </b-link>
            <b-link href="#"
                    v-if="['IMG', 'PDF'].includes(obj.formato) && hasFolderPermission(folderPermission.DOWNLOAD, folder)"
                    @click="onPreviewFile(obj)"
                    class="ml-2"
                    :class="{'text-danger':(Boolean(obj.status) === false)}"
                    v-b-tooltip.hover title="Clique para visualizar o conteúdo">
              <i class="far fa-eye text-default" style="font-size: 14px;"></i>
            </b-link>
          </TableColumn>
          <TableColumn v-if="!folder.gedChecklistID && !obj.gedChecklistTipo" :IsTextUnclicable="true" :status="obj.status" :value="obj.gedTipo ? obj.gedTipo.nome : null" />
          <TableColumn v-if="!obj.gedChecklistTipo" :IsTextUnclicable="true" :status="obj.status" :value="obj.gedAssunto ? obj.gedAssunto.nome : null" />
          <TableColumn v-if="!obj.gedChecklistTipo" :IsTextUnclicable="true" :status="obj.status" :value="obj.versao.toString()" />
          <TableColumn v-if="!obj.gedChecklistTipo" :IsTextUnclicable="true" :status="obj.status" :value="formatSize(obj.tamanho)" />
          <TableColumn v-if="!obj.gedChecklistTipo" :IsTextUnclicable="true" :status="obj.status" :value="obj.dataAcaoFormatada" />
          <TableColumn v-if="!obj.gedChecklistTipo" :IsCustom="true" :status="obj.status" >
            <div v-if="obj.gedArquivoTags && obj.gedArquivoTags.length">
              <span :id="'linkTags' + index">
                <i class="fas fa-bookmark text-success" style="font-size: 14px;"></i>
              </span>
              <b-tooltip :target="'linkTags' + index" triggers="hover" boundary="window" variant="info">
                <b-badge pill v-for="tag in obj.gedArquivoTags" :key="tag.id" class="m-1" style="font-size: 12px;" variant="dark">
                  {{ getTagName(tag) }}
                </b-badge>
              </b-tooltip>
            </div>
            <span v-else>
              <i class="far fa-bookmark text-default" style="font-size: 14px;"></i>
            </span>
          </TableColumn>
          <TableColumn v-if="!obj.gedChecklistTipo" :IsCustom="true" :status="obj.status">
            <div v-if="obj.observacao">
              <span id="linkObs" v-b-tooltip.hover :title="obj.observacao">
                <i class="fas fa-comments text-success" style="font-size: 14px;"></i>
              </span>
            </div>
            <span v-else>
              <i class="far fa-comments text-default" style="font-size: 14px;"></i>
            </span>
          </TableColumn>
          <TableColumn v-if="!obj.gedChecklistTipo" :IsDateOnlyUnclicable="true" :status="obj.status" :value="obj.inicio" />
          <TableColumn v-if="!obj.gedChecklistTipo" :IsDateOnlyUnclicable="true" :status="obj.status" :value="obj.validade" />
          <TableColumn v-if="!obj.gedChecklistTipo && selectedCount < 2" :IsActionsButtons="true"
                       :HasDelete="hasFolderPermission(folderPermission.DELETE, folder)"
                       v-on:Delete="onDeleteFile(obj)"
                       :status="obj.status">
            <template>
              <b-link href="#" @click="onDownloadFile(obj)">
                <i class="fas fa-download text-default mx-2" style="font-size: 14px;"></i>
              </b-link>
              <b-link href="#" @click="onEditFile(obj)">
                <i class="fas fa-edit text-default mx-2" style="font-size: 14px;" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonEdit"></i>
              </b-link>
            </template>
          </TableColumn>
          <TableColumn v-if="obj.gedChecklistTipo" colspan="13" :IsCustom="true" classCss="text-left checklist">
            <div class="row py-0 px-0 checklist-div" :class="{'enabled': obj.status > 0, 'disabled': obj.status === 0}">
              <div class="col-11 text-secondary" style="padding-left: 0.5rem;" >
                <i class="mr-1" v-if="obj.status !== 0" :class="{'fas fa-exclamation-circle text-danger': !obj.check && obj.status > 0, 'fas fa-check-circle text-info': obj.check && obj.status > 0}"></i>
                <b-button size="sm" variant="warning" v-else disabled style="padding:0.1rem; font-size:8px;">N/A</b-button>
                <span>{{ obj.gedChecklistTipo.gedTipo.nome }}</span>
              </div>
              <div class="col-1 text-center pr-1">
                <b-button ref="btnNA" v-if="!obj.check || obj.status === 0" @click="onUpdateChecklistType(obj)" size="sm" squared variant="outline-danger" style="padding:0.1rem; font-size:8px;">
                  <i class="fas" :class="{'fa-minus':obj.status !== 0, 'fa-plus':obj.status === 0}"></i>
                </b-button>
              </div>
            </div>
          </TableColumn>
        </tr>
      </Tables>
    </div>
    <b-modal id="preview-modal" scrolLabel hide-footer centered size="xl">
      <div style="height: 100%;" class="row justify-content-center align-items-center">
        <img :src="'data:image/jpeg;base64,' + previewIMG" v-if="previewIMG" alt="" style="max-width: 90%; width: auto; height: min-content; max-height: 90%;">
        <vue-pdf-app :pdf="'data:application/pdf;base64,' + previewPDF" theme="light" :config="pdfConfig" v-if="previewPDF" style="width: 100%; height: 100%;"></vue-pdf-app>
      </div>
    </b-modal>
    <div class="mb-1"></div>
  </div>
</template>

<script>
import DocContent from './doccontent.js'
export default DocContent
</script>

<style scoped>
i.fa-star {
  font-size: 14px;
}

a {
  font-size: 12px;
}

i.fa-star:hover {
  color: black;
}

* >>> div#preview-modal .modal-dialog .modal-content {
  position: absolute;
  height: 100%;
}

* >>> .modal-body {
  padding-top: 0;
}

* >>> .checklist {
  padding: 3px;
  border-left-style: hidden;
  border-right-style: hidden;
  border-bottom-style: hidden;
}

* >>> .checklist div {
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  font-weight: bold;
}

* >>> .checklist-div {
  background-color: #e6e9ea94;
}

* >>> .checklist-div.enabled {
  -webkit-box-shadow: 0px 0.5px 1px 0.5px grey;
  box-shadow: 0px 0.5px 1px 0.5px gray;
}

table td {
  padding: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/documents/components/content/doccontent.vue